import { render, staticRenderFns } from "./media-rejection-batch-dialog.vue?vue&type=template&id=49bee322&scoped=true"
import script from "./media-rejection-batch-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./media-rejection-batch-dialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./media-rejection-batch-dialog.vue?vue&type=style&index=0&id=49bee322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bee322",
  null
  
)

export default component.exports